import { gamePadService } from '../../services/helperServices/GamePadService';
import { gameAnimations } from '../../services/helperServices/GameAnimationService';
import { ballDrawer } from '../balls/BallDrawer';
import { gameService } from '../../services/apiServices/GameService';
import { spinResponseService } from '../../services/helperServices/SpinResponseService';
import { backgroundDrawer } from '../background/BackgroundDrawer';
import { autoSpinHelper } from '../../services/helperServices/AutoSpinService';
import { userService } from '../../services/helperServices/UserService';
import { bonusSpinService } from '../../services/helperServices/BonusSpinService';
import { delay } from 'bog-arcade-core-ui/helpers';
import { bigWinService } from '../../services/helperServices/BigWinService';
import { soundService } from '../../services/helperServices/SoundService';

export const resetGamePadState = event => {
  event.stopPropagation();
  gamePadService.closeSpinCount();
  gamePadService.closeQuickBets();
};

export const handleAutoSpinClick = (event) => {
  soundService.playSingleClick();
  gamePadService.closeQuickBets();
  if (gamePadService.spinCountsOpenedState && gamePadService.autoSpinState) {
    gamePadService.closeSpinCount();
    gamePadService.disableAllWhileAutoSpin();
    autoSpinHelper.start(event);
  } else if (gamePadService.autoSpinState) {
    gamePadService.openSpinCount();
  }
};

export const bonusSpin = () => {
  bonusSpinService.start();
};

export const incrementAutoSpinCount = (event) => {
  soundService.playBetAmountChange();
  event.stopPropagation();
  gamePadService.nextSpinCount();
};

export const decrementAutoSpinCount = (event) => {
  soundService.playBetAmountChange();
  event.stopPropagation();
  gamePadService.prevSpinCount();
};

export const incrementNextQuickBet = (event) => {
  if (gamePadService.betAmountState) {
    soundService.playBetAmountChange();
    event.stopPropagation();
    gamePadService.nextQuickBet();
  }
};

export const decrementNextQuickBet = (event) => {
  if (gamePadService.betAmountState) {
    soundService.playBetAmountChange();
    event.stopPropagation();
    gamePadService.prevQuickBet();
  }
};

export const handleMobileQuickBetsClick = () => {
  if (gamePadService.betAmountState) {
    gamePadService.closeSpinCount();
    if (gamePadService.quickBetsOpenedState) {
      gamePadService.closeQuickBets();
    } else {
      gamePadService.openQuickBets();
    }
  }
};

export const handleQuickBetsIndexChange = (index, { prev, next }) => {
  const { length } = gamePadService.quickBets;
  next.alpha = 1;
  prev.alpha = 1;
  if (index === 0) prev.alpha = .5;
  if (index === length - 1) next.alpha = .5;
};

export const handleSpinCountsActiveChange = (index, { prev, next }) => {
  const { length } = gamePadService.spinCounts;
  next.alpha = 1;
  prev.alpha = 1;
  if (index === 0) prev.alpha = .2;
  if (index === length - 1) next.alpha = .2;
};

export const handleSpinClick = (event) => {
  soundService.playSpin();
  const betAmount = gamePadService.quickBet;
  resetGamePadState(event);
  if (gamePadService.spinState && userService.checkBalance(betAmount)) {
    gamePadService.disableAll();
    gameService.spin().then((res) => {
      userService.updateBalance(res.balance, () => userService.minusBalance(betAmount));
      if (res.odd) {
        soundService.playBreakStone();
        gameAnimations.breakBall().then(() => {
          ballDrawer.application.breakBall().then(() => {
            gamePadService.enableAll();
            spinResponseService.setData(res);
          });
        });
        ballDrawer.application.hideBall();
        gameAnimations.breakBallBoom();
        if (bigWinService.check(res)) {
          bigWinService.start();
        } else {
          backgroundDrawer.application.setWinOdd(res);
        }
        userService.plusBalance(res.winAmount);
      } else {
        soundService.playCrackStone();
        gameAnimations.crackBall();
        gameAnimations.crackParticles();
        delay(() => {
          ballDrawer.application.crackBall().then(() => {
            gamePadService.enableAll();
            spinResponseService.setData(res);
          });
        }, 100);
      }
    })
      .catch(() => {
        gamePadService.enableAll();
      });

  }
};

export const handleSwitchBall = (event) => {
  if (gamePadService.switchButtonState) {
    soundService.playSingleClick();
    resetGamePadState(event);
    if (gamePadService.switchButtonState) {
      gamePadService.disableSwitchButtonState();
      gamePadService.disableSpin();
      ballDrawer.application.switch().then(() => {
        gamePadService.enableSpin();
        gamePadService.enableSwitchButtonState();
      });
    }
  }
};

export const handleSpinButtonCLick = (event) => {
  if (autoSpinHelper.autoSpinActive) {
    return;
  } else {
    handleSpinClick(event);
  }
};

export const switchButtonSubscriber = (state, texture) => {
  texture.alpha = state ? 1 : .5;
};

export const betAmountSubscriber = (state, texture) => {
  texture.alpha = state ? 1 : .5;
};

export const autoSpinSubscriber = (state, texture) => {
  texture.alpha = state ? 1 : .5;
};

export const spinButtonSubscriber = (state, texture) => {
  texture.alpha = state ? 1 : .5;
};
